import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-date-picker-demo',
  templateUrl: './date-picker-demo.component.html',
  styleUrls: ['./date-picker-demo.component.scss']
})
export class DatePickerDemoComponent {
  demoForm: FormGroup;
  minDate: Date = new Date(2020, 0, 1);
  maxDate: Date = new Date(2030, 11, 31);

  constructor(private fb: FormBuilder) {
    this.demoForm = this.fb.group({
      basicDate: [null],
      withMinMax: [null],
      disabledDate: [null],
      customPlaceholder: [null],
      yearPicker: [null]
    });
  }

  onDateChange(date: Date) {

  }

  onYearChange(year: number) {

  }

  onSubmit() {

  }
} 